export const countryCodeJp = "+81";

export const toFirebaseFormat = (phoneNumber: string): string => {
  return countryCodeJp + Array.from(phoneNumber).splice(1).join("");
};
